import React, { createContext, useContext, ReactNode } from 'react';
import { NavInstrumentationService, DatadogNavInstrumentation } from './nav-instrumentation';

let globalServiceInstance: NavInstrumentationService | null = null;

export const getGlobalNavInstrumentation = (): NavInstrumentationService | null => {
  return globalServiceInstance;
};

const NavInstrumentationContext = createContext<NavInstrumentationService | null>(null);

export const NavInstrumentationProvider = ({ children }: { children: ReactNode }) => {
    const service = React.useMemo(() => {
    const instance = new DatadogNavInstrumentation();
    
    globalServiceInstance = instance;
    
    return instance; 
  }, []);
  
  return (
    <NavInstrumentationContext.Provider value={service}>
      {children}
    </NavInstrumentationContext.Provider>
  );
};

export const useNavInstrumentation = (): NavInstrumentationService => {
  const context = useContext(NavInstrumentationContext);
  if (!context) {
    throw new Error('useNavInstrumentation must be used within NavInstrumentationProvider');
  }
  return context;
};